export const productRulesApi = {
  // PRODUCT GROUPS
  getProductGroups: client =>
    client('product-rules/product-groups', {method: 'GET'}),
}
